export default "__VITE_ASSET__BIMTT600__"